import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import * as actions from 'modules/actions/account';
import _ from 'lodash';
import { Modal, Radio } from '@beehive/components';

import PropTypes from 'prop-types';
import messages from 'messages';

interface LanguageModalProps {
  setLanguage: Function;
  onMenuVisibleChange: Function;
  language: string;
}

class LanguageModal extends React.Component<LanguageModalProps, any> {

  public static contextTypes = {
    intl: PropTypes.object,
  };

  constructor(props: LanguageModalProps) {
    super(props);
    this.state = {
      showModal: false,
      submitLoading: false,
      defaultLocale: props.language,
    };
  }
  public handleModalSubmit = (val: string) => {
    const { setLanguage } = this.props;
    const { defaultLocale } = this.state;
    if (defaultLocale !== val) {
      this.setState({ submitLoading: true });
      setLanguage(val).then(() => {
        this.handleHide();
      }).catch(() => {
        this.setState({ submitLoading: false });
      });
    } else {
      this.handleHide();
    }
  }

  public handleShow = (e?: React.MouseEvent) => {
    const { onMenuVisibleChange } = this.props;
    const { showModal } = this.state;
    e && e.stopPropagation();
    !showModal && onMenuVisibleChange(false);
    this.setState({showModal: true});
  }

  public handleHide = () => {
    this.setState({ showModal: false, value: undefined, submitLoading: false });
  }

  public handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ value: e.target.value });
  }

  public render() {
    const { intl } = this.context;
    const { language } = this.props;
    const { showModal, value, submitLoading } = this.state;
    const val = value || language;
    return (
      <span onClick={(e) => e.stopPropagation()}>
        <span onClick={this.handleShow}>{intl.formatMessage(messages.preferences)}</span>
        <Modal
          title={intl.formatMessage(messages.preferences)}
          width={500}
          onOk={() => this.handleModalSubmit(val)}
          onCancel={this.handleHide}
          confirmLoading={submitLoading}
          visible={showModal}
          className="mpc-modal-language-setting"
          destroyOnClose
          closable
          maskClosable={false}
        >
          <div className="">
            <div style={{ marginBottom: '16px' }}>{intl.formatMessage(messages.language)}</div>
            <Radio.Group
              onChange={this.handleValueChange}
              value={val}
              items={[
                {label: '简体中文', value: 'zh-CN'},
                {label: 'English', value: 'en'},
              ]}
              style={{ marginLeft: '24px' }}
            />
          </div>
        </Modal>
      </span>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  const language = state.account.language;
  return { language };
};

const mapDispatchToProps = (dispatch: Dispatch<actions.AccountActions>) => {
  return bindActionCreators({
    setLanguage: actions.setLanguage,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageModal);
